import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { posts } from "@/data/blog";
import { RevealBlock } from "@/components/Reveal";

export default function Blog() {
  return (
    <>
      <SEO
        title="Journal · Security Insight from Nova Scotia"
        description="Articles from Nova Scotia Security Services — mining, marine, corporate, event, and de-escalation-first security practice."
        path="/journal"
      />
      <section className="max-w-[1600px] mx-auto px-6 lg:px-12 pt-16 md:pt-24 pb-24">
        <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#C17A43] mb-8">
          — Journal
        </p>
        <RevealBlock>
          <h1 className="font-serif text-[clamp(3rem,9vw,9rem)] leading-[0.88] tracking-tighter text-[#111111]">
            Field notes<br />
            <span className="italic text-[#184C59]">from the province.</span>
          </h1>
        </RevealBlock>

        <div className="mt-20 border-t border-[#111111]">
          {posts.map((p, i) => (
            <Link
              key={p.slug}
              to={`/journal/${p.slug}`}
              className="grid grid-cols-12 border-b border-[#D9D6D0] gap-4 py-10 md:py-14 group items-center hover:bg-[#111111] hover:text-[#F5F3EF] transition-colors duration-500 px-4 -mx-4"
            >
              <div className="col-span-1 font-mono text-[10px] uppercase tracking-[0.28em] opacity-60">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="col-span-11 md:col-span-6">
                <p className="font-mono text-[10px] uppercase tracking-[0.28em] opacity-60 mb-3">
                  {p.category} · {p.date} · {p.readTime}
                </p>
                <h2 className="font-serif text-3xl md:text-5xl leading-tight tracking-tight group-hover:italic transition-[font-style] duration-300">
                  {p.title}
                </h2>
              </div>
              <div className="col-span-12 md:col-span-4 md:pl-8">
                <p className="font-sans text-sm md:text-base opacity-70 leading-relaxed">
                  {p.excerpt}
                </p>
              </div>
              <div className="col-span-12 md:col-span-1 md:text-right text-lg opacity-40 group-hover:opacity-100 group-hover:translate-x-1 transition-transform">
                →
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
